export default __webpack_public_path__ + "static/media/top_quote.b36b9142.svg";